// Central Arizona Constants

// Entitlements
export const ENTITLEMENT_URL = `/api/entitlement`;
export const ALL_ENTITLMENTS_URL = `${ENTITLEMENT_URL}/all_entitlements`;
export const PRIORITY_POOL_ENTITLMENTS_URL = `${ENTITLEMENT_URL}/priority_entitlements`;
export const ENTITY_ENTITLMENTS_URL = `${ENTITLEMENT_URL}/entity_entitlements`;
export const DIFFERENCE_ENTITY_ENTITLMENTS_URL = `${ENTITLEMENT_URL}/entitlement_difference`;
export const ENTITLMENTS_BY_YEAR_URL = `${ENTITLEMENT_URL}/access_difference`;
export const ENTITLMENTS_RANGE_URL = `${ENTITLEMENT_URL}/entitlement_difference_range`;
export const PER_PERSON_DIFFERENCE_ENTITY_ENTITLMENTS_URL = `${ENTITLEMENT_URL}/per_person_entitlement_difference`;
